import { APPT_BOOKING_REASON_MAX } from "common/constants";
import { string } from "yup";
import * as Yup from "yup";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export const apptBookReasonValidation = (required = true) => {
	let schema = string();

	if (required) {
		schema = schema.required("Required");
	} else {
		schema = schema.notRequired();
	}

	schema = schema.max(APPT_BOOKING_REASON_MAX, `Must be at most ${APPT_BOOKING_REASON_MAX} characters`);

	return schema;
};



export const phoneValidation = (phoneField = "phone", countryCodeField = "country_code", required = false) =>
	Yup.mixed().test("phone-validation", "Invalid phone number", function () {
		const { path, parent, createError } = this;
		const phone = parent[phoneField];
		const countryCode = parent[countryCodeField];

		if (!required && (!phone || !countryCode)) {
			return true;
		}

		// Required check
		if (required && (!phone || !countryCode)) {
			return createError({ path, message: "Phone and country code are required" });
		}

		const fullNumber = `${countryCode}${phone}`.replace(/\s+/g, "");

		const phoneNumber = parsePhoneNumberFromString(fullNumber);

		if (!phoneNumber || !phoneNumber.isValid()) {
			return createError({ path, message: "Invalid phone number" });
		}

		return true;
	});

	export const createPhoneSchema = ({
		label = "Phone number",
		required = true,
	} = {}) => {
		let schema = Yup.string();
	
		if (required) {
			schema = schema.required(`${label} is required`);
		}
	
		return schema.test(
			"is-valid-phone",
			`Invalid ${label.toLowerCase()}`,
			(value) => {
				if (!value) return !required;
	
				// Auto-detect country from "+xx" prefix
				const phone = parsePhoneNumberFromString(value);
	
				return phone ? phone.isValid() : false;
			}
		);
	};